import { Fragment } from 'react';
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider';
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types';
import QuoteOrderStatusBar, { QuoteOrderStatusBarNew, QuoteOrderStatusBarProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderQuoteLayout/QuoteOrderStatusBar';
import QuoteOrderCreateStepButtons, { QuoteOrderCreateStepButtonsNew } from '../QuoteOrderCreateStepButtons';

type QuoteOrderCreateStepHeaderProps = & QuoteOrderStatusBarProps & OrderStepButtonsBaseComponentProps

const QuoteOrderCreateStepHeaderDecider: React.FC<QuoteOrderCreateStepHeaderProps> = ({...rest}) => {
    return (
        <AppStyleDecider DefaultComponent={QuoteOrderCreateStepHeaderDefault} NewComponent={QuoteOrderCreateStepHeaderNew} {...rest} />
    )
}

const QuoteOrderCreateStepHeaderDefault: React.FC<QuoteOrderCreateStepHeaderProps> = ({...rest}) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <QuoteOrderStatusBar {...rest} />
            <QuoteOrderCreateStepButtons {...rest} />
        </div>
    )
}

const QuoteOrderCreateStepHeaderNew: React.FC<QuoteOrderCreateStepHeaderProps> = ({...rest}) => {
    return (
        <Fragment>
            <QuoteOrderStatusBarNew {...rest} />
            <QuoteOrderCreateStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default QuoteOrderCreateStepHeaderDecider